import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { clearGetFacebookClientApps, getFacebookClientApps } from '../../../../../../modules/actions/choices'
import { FACEBOOK_BUSINESS_MANAGER_ID } from '../../../../../../pages/Settings/RightHolderProfile/fields'
import { selfAccountSelector } from '../../../../../../modules/selectors/selfAccounts'

export default function useGetAppsData() {
  const dispatch = useDispatch()

  const { facebook_bm_id: facebookBmId } = useSelector(selfAccountSelector)

  useEffect(() => {
    if (facebookBmId) {
      dispatch(getFacebookClientApps({ [FACEBOOK_BUSINESS_MANAGER_ID]: facebookBmId }))
    }
  }, [dispatch, facebookBmId])

  useEffect(() => {
    return () => {
      dispatch(clearGetFacebookClientApps())
    }
  }, [dispatch])
}
